import { Sorters, startCaseWithSpace } from 'utils/tableUtils'
import { getVocabulary } from 'components/Vocabulary';
import { getFeatureFlags_UNSAFE } from "contexts/FeatureFlagContext";

export function generatePermissionTreeData(data = {}, level = 0, parent) {
    if (level > 1) {
        return;
    }

    const CATEGORY_WITH_FLAG = {
        ASSESSMENTS: "PENTEST_MODULE",
        RISK_REGISTER: "EXCEPTION_MODULE",
        SUPPLY_CHAIN: "MANAGE_SBOM"
    }

    const CUSTOM_CATEGORY_MAPPING = {
        NOTIFICATION_REPORT: "Report",
        CREATE_NOTIFICATION_REPORT: "Create Report",
        UPDATE_NOTIFICATION_REPORT: "Update Report",
        DELETE_NOTIFICATION_REPORT: "Delete Report",
        CREATE_REPORT: "Create Compliance",
        UPDATE_REPORT: "Update Compliance",
        DELETE_REPORT: "Delete Compliance",
        READ_REPORT: "Read Compliance",
        BUSINESS_UNIT: "Organization",
        UPDATE_BUSINESS_UNIT: "Update Organization",
        CREATE_BUSINESS_UNIT: "Create Organization",
        PROJECT: getVocabulary("project"),
        CREATE_PROJECT: `Create ${getVocabulary("project")}`,
        READ_PROJECT: `Read ${getVocabulary("project")}`,
        UPDATE_PROJECT: `Update ${getVocabulary("project")}`,
        DELETE_PROJECT: `Delete ${getVocabulary("project")}`,
        PRODUCT: getVocabulary("product"),
        CREATE_PRODUCT: `Create ${getVocabulary("product")}`,
        UPDATE_PRODUCT: `Update ${getVocabulary("product")}`,
        DELETE_PRODUCT: `Delete ${getVocabulary("product")}`,
        SUB_PRODUCT: getVocabulary("subProduct"),
        CREATE_SUB_PRODUCT: `Create ${getVocabulary("subProduct")}`,
        UPDATE_SUB_PRODUCT: `Update ${getVocabulary("subProduct")}`,
        DELETE_SUB_PRODUCT: `Delete ${getVocabulary("subProduct")}`,
        CI_JOB_CONFIG: "CI Job Config",
        TEAMS: getVocabulary("team"),
        DELETE_TEAMS: `Delete ${getVocabulary("team")}`,
        CREATE_TEAMS: `Create ${getVocabulary("team")}`,
        UPDATE_TEAMS: `Update ${getVocabulary("team")}`,
        UPDATE_FINDINGS_PROJECT: `Assign ${getVocabulary("project")}`,
        UPDATE_FINDINGS_RISK_REGISTER: `Assign ${getVocabulary("exception")}`,
        UPDATE_FINDINGS_ASSESSMENT: `Assign ${getVocabulary("assessment")}`,
        MARK_ACCEPT_RISK: `Mark ${getVocabulary("acceptRisk")}`,
        MARK_CONFIRM: `Mark ${getVocabulary("confirmed")}`,
        MARK_FALSE_POSITIVE: `Mark ${getVocabulary("falsePositive")}`,
        MARK_IN_PROGRESS: `Mark ${getVocabulary("inProgressStatus")}`,
        MARK_CONTROLLED: `Mark ${getVocabulary("controlledStatus")}`,
        MARK_MITIGATED: `Mark ${getVocabulary("mitigated")}`,
        MARK_REOPEN: `Mark Re-${getVocabulary("open")}`,
        MARK_SUPPRESSED: `Mark ${getVocabulary("suppressed")}`,
        MARK_TRIAGE: `Mark ${getVocabulary("triageStatus")}`,
        RISK_REGISTER: getVocabulary("exception"),
        READ_RISK_REGISTER: `Read ${getVocabulary("exception")}`,
        APPROVE_RISK_REGISTER: `Approve ${getVocabulary("exception")}`,
        CREATE_RISK_REGISTER: `Create ${getVocabulary("exception")}`,
        UPDATE_RISK_REGISTER: `Update ${getVocabulary("exception")}`,
        DELETE_RISK_REGISTER: `Delete ${getVocabulary("exception")}`,
        MODIFY_APPROVERS_LIST: 'Modify Approvers List',
        ALERTS: "Notifications",
        READ_ALERT: "Read Notifications",
        UPDATE_ALERT: "Update Notifications",
        ASSESSMENTS: getVocabulary("assessment"),
        CREATE_ASSESSMENTS: `Create ${getVocabulary('assessment')}`,
        DELETE_ASSESSMENTS: `Delete ${getVocabulary('assessment')}`,
        READ_ASSESSMENTS: `Read ${getVocabulary('assessment')}`,
        UPDATE_ASSESSMENTS: `Update ${getVocabulary('assessment')}`,
        AI_EXPOSURE_MANAGEMENT: "AI Exposure Management",
        READ_AI_INVENTORY: "Read AI Inventory and Approvals",
        WRITE_AI_INVENTORY: "Update AI Inventory and Approvals"
    };
    const { permissionSet = data } = data;
    const categories = Object.keys(permissionSet);
    const getTitle = (category) => CUSTOM_CATEGORY_MAPPING[category] || startCaseWithSpace(category);

    return categories.map(c => {
        const flag = CATEGORY_WITH_FLAG[c];
        if (flag && !getFeatureFlags_UNSAFE()[flag]) {
            return null; // filter out the category if the flag is not enabled
        }
        return {
            title: getTitle(c),
            key: parent ? `${parent}#${c}` : c /*  + level */,
            children: generatePermissionTreeData(permissionSet[c], level + 1, c),
        }
    }).filter(Boolean).sort(Sorters.STRING("title"))
}